// -- Packages
import React from "react";
import { observer } from "mobx-react";
// -- Prime React
// -- Local
import { SearchPanel } from "./components/SearchPanel";
import { ServicesTable } from "./components/ServicesTable";

type Props = {};

export const ServiceSearch: React.FC<Props> = observer((props: Props) => {
   return (
      <>
         <main id="main-content">
             <div className="p-grid p-mt-2">
                <div className="p-col-12 p-sm-12 p-md-12 ">
                   <SearchPanel />
                </div>
                <div className="p-col-12 p-sm-12 p-md-12 ">
                   <ServicesTable />
                </div>
             </div>
         </main>
      </>
   );
});
